import type {
  MidiChannel,
  MidiInstrument,
  MidiTrack,
} from "@midi-fantom-utils/midi-core";

/**
 * Control Changes, которые нужно оставить в финальном файле по умолчанию.
 *
 * 1  — Modulation
 * 7  — Volume
 * 10 — Pan
 * 11 — Expression
 * 64 — Sustain Pedal
 * 91 — Reverb Send
 * 93 — Chorus Send
 */
export const ALLOWED_CONTROL_CHANGES = [1, 7, 10, 11, 64, 91, 93] as const;

export const createEmptyTrack = (channel: MidiChannel = 0): MidiTrack => ({
  name: "",
  channel,
  instrument: {
    family: "piano",
    number: 0,
    name: "acoustic grand piano",
    percussion: false,
  },
  notes: [],
  controlChanges: new Map(),
  programChanges: [],
  pitchBends: [],
  sysex: [],
  meta: [],
  unknownMeta: [],
});

export const cloneInstrument = (i: MidiInstrument): MidiInstrument => ({
  family: i.family,
  number: i.number,
  name: i.name,
  percussion: i.percussion,
});